import { z } from 'zod';
import { ImageRatio } from '../artifacts/images/values.mjs';
import { mediaSourceRecipeSchema } from './app-media-source.mjs';

export const appMediaDeclarationSchema = z
  .strictObject({
    kind: z.literal('image'),
    ratio: ImageRatio,
    allowedRatios: z.array(ImageRatio).min(1).max(5),
    cropSafe: z.boolean(),
    source: mediaSourceRecipeSchema.optional(),
  })
  .superRefine((media, ctx) => {
    if (
      new Set(media.allowedRatios).size !== media.allowedRatios.length ||
      !media.allowedRatios.includes(media.ratio)
    )
      ctx.addIssue({
        code: 'custom',
        path: ['allowedRatios'],
        message: 'Unique allowed ratios must include the selected ratio',
      });
  });

export function validateMediaSourceReferences(manifest, ctx) {
  const tools = new Set(manifest.tools.map((tool) => tool.id));
  manifest.collections.forEach((collection, collectionIndex) => {
    collection.fields.forEach((field, fieldIndex) => {
      if (field.media?.source && !tools.has(field.media.source.toolId))
        ctx.addIssue({
          code: 'custom',
          path: ['collections', collectionIndex, 'fields', fieldIndex, 'media', 'source', 'toolId'],
          message: 'Media source must reference an exact declared tool',
        });
    });
  });
}
